import { FC, memo } from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import styles from './style.module.css';
import type { SideMenuItem as SideMenuItemType } from './types';

interface Props {
  item: SideMenuItemType;
  active: boolean;
  expanded: boolean;
}

const SideMenuItemComponent: FC<Props> = ({ item, active, expanded }) => (
  <Link
    to={item.path}
    target={item.external ? '_blank' : undefined}
    rel={
      item.onOpen ? 'opener' : item.external ? 'noopener noreferrer' : undefined
    }
    onClick={
      item.onOpen
        ? (event) => {
            event.preventDefault();
            item.onOpen?.();
          }
        : undefined
    }
    onAuxClick={
      item.onOpen
        ? (event) => {
            if (event.button === 1) {
              event.preventDefault();
              item.onOpen?.();
            }
          }
        : undefined
    }
    className={cn(styles.item, { [styles.itemActive]: active })}
    aria-current={active ? 'page' : undefined}
    aria-hidden={expanded ? undefined : true}
    tabIndex={expanded ? undefined : -1}
    data-testid={`side-menu-item-${item.key}`}
  >
    <span className={styles.itemLabel} title={item.label}>
      {item.label}
    </span>
  </Link>
);

export const SideMenuItem = memo(SideMenuItemComponent);
SideMenuItem.displayName = 'SideMenuItem';
